import React from "react";
import { connect } from "react-redux";
import { replace } from "react-router-redux";
import { RoutesInvoker } from "../../routesInvoker";
import ResetForm from "./../../../shared/components/authentication/resetPasswordForm";
import { ActionPromises } from "./../../state/actionPromises";

interface StateProps {
  location: any;
}

interface DispatchProps {
  completeForgotPassword: (request: IResetPasswordRequest) => any;
  navigateToLogin: () => void;
}

const mapDispatchToProps = (dispatch): DispatchProps =>  {
  return {
    navigateToLogin: () => dispatch(replace(RoutesInvoker.login())),
    completeForgotPassword: (request: IResetPasswordRequest) => dispatch(ActionPromises.resetPassword(request)),
  };
};

/** Thin wrapper */
class ResetPassword extends React.Component<DispatchProps & StateProps, null> {
  constructor(props) {
    super(props);
  }

  private setPassword = async (newPass: string) => {
    const hash = (this.props.location.hash as string).substr(1);
    const [ username, code ] = hash.split("~");

    if (!username || !code) {
      throw new Error("you seem to be in the wrong place. If you want to reset your password, please return to the login page and try again");
    }

    const request: IResetPasswordRequest = {
      username,
      password: newPass,
      passwordResetToken: code,
    };

    await this.props.completeForgotPassword(request);
    this.props.navigateToLogin();
  }

  public render() {
    return <ResetForm setPassword={p => this.setPassword(p)} routeToLogin={RoutesInvoker.login()} />;
  }
}

export default connect(null, mapDispatchToProps)(ResetPassword);
